import { render } from "./MainDTTvaDinhDanh.vue?vue&type=template&id=19e654b9"
import script from "./MainDTTvaDinhDanh.vue?vue&type=script&lang=js"
export * from "./MainDTTvaDinhDanh.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__